import type { ReactElement, ReactNode } from 'react';
import React, { Children } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { COLORS } from 'Components/utils/color/colors';
import { ArrowButton } from 'Components/frameworks/arrow-button/ArrowButton';
import { ProgressBar } from 'Components/frameworks/progress-bar/ProgressBar';
import { SliderHandler } from 'Components/frameworks/slider-handler/SliderHandler';
type Props = {
  children: ReactNode;
  className?: string;
  hasInfiniteScroll?: boolean;
  initialIndex?: number;
  nextLabel?: string;
  previousLabel?: string;
};
export const Carousel = ({
  children,
  className,
  hasInfiniteScroll,
  initialIndex = 0,
  nextLabel,
  previousLabel,
}: Props) => {
  const childItems = Children.toArray(children).filter(Boolean) as ReactElement[];
  const childrenCount = childItems.length;

  if (!childrenCount) {
    return null;
  }

  return (
    <div className={classnames('relative isolate overflow-hidden', className)}>
      <SliderHandler
        className="h-full w-full"
        hasInfiniteScroll={hasInfiniteScroll}
        hasKeyboardSupport
        hasSwipeSupport
        initialIndex={initialIndex}
        items={childItems}
        nbItemsToShow={1}
      >
        {({
          hasControls,
          index,
          isNextControlDisabled,
          isPreviousControlDisabled,
          itemsNode,
          onNext,
          onPrevious,
        }) => (
          <div className="relative isolate flex w-full flex-1 pb-20">
            {itemsNode}
            {hasControls && (
              <div className="fap-10 pointer-events-none absolute inset-0 m-auto flex w-full items-center justify-between px-20">
                {!isPreviousControlDisabled && (
                  <ArrowButton
                    className="pointer-events-auto z-1 me-auto shadow-sm"
                    color={COLORS.WHITE}
                    label={previousLabel}
                    onClick={onPrevious}
                  />
                )}
                {!isNextControlDisabled && (
                  <ArrowButton
                    className="pointer-events-auto z-1 ms-auto shadow-sm"
                    color={COLORS.WHITE}
                    label={nextLabel}
                    onClick={onNext}
                    rotation={180}
                  />
                )}
              </div>
            )}
            {hasControls && (
              <div className="absolute bottom-0 left-0 w-full">
                <ProgressBar color={COLORS.WHITE} max={childrenCount} min={1} value={index + 1} />
              </div>
            )}
          </div>
        )}
      </SliderHandler>
    </div>
  );
};
